/**
 * API services pour la gestion des suppléments
 */

// API Base URL - depuis les variables d'environnement
import API_BASE_URL from '../config/api';

// Helper function for API calls
const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
    ...options,
  };

  try {
    const response = await fetch(url, defaultOptions);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

// ==================== SUPPLEMENT ROUTES ====================

// Get supplements for a specific dish
export const getDishSupplements = async (dishId) => {
  try {
    const data = await apiCall(`/supplements/dish/${dishId}`);
    return data;
  } catch (error) {
    console.error('Error fetching dish supplements:', error);
    // Fallback: return empty array if API fails
    return [];
  }
};

// Calculate item price with supplements
export const calculateItemPrice = async (dishId, quantity, supplements) => {
  try {
    const requestData = {
      dish_id: dishId,
      quantity: quantity,
      supplements: supplements
    };
    
    const data = await apiCall('/supplements/calculate-item-price', {
      method: 'POST',
      body: JSON.stringify(requestData)
    });
    
    return data;
  } catch (error) {
    console.error('Error calculating item price:', error);
    throw error;
  }
};

// Calculate cart total with supplements
export const calculateCartTotal = async (cartItems) => {
  try {
    const data = await apiCall('/supplements/calculate-cart-total', {
      method: 'POST',
      body: JSON.stringify(cartItems)
    });
    
    return data;
  } catch (error) {
    console.error('Error calculating cart total:', error);
    throw error;
  }
};

// Get supplement by ID
export const getSupplement = async (supplementId) => {
  try {
    const data = await apiCall(`/supplements/${supplementId}`);
    return data;
  } catch (error) {
    console.error('Error fetching supplement:', error);
    throw error;
  }
};

// Create a new supplement (admin only)
export const createSupplement = async (supplementData) => {
  try {
    const data = await apiCall('/supplements/', {
      method: 'POST',
      body: JSON.stringify(supplementData)
    });
    
    return data;
  } catch (error) {
    console.error('Error creating supplement:', error);
    throw error;
  }
};

// Update supplement (admin only)
export const updateSupplement = async (supplementId, supplementData) => {
  try {
    const data = await apiCall(`/supplements/${supplementId}`, {
      method: 'PUT',
      body: JSON.stringify(supplementData)
    });
    
    return data;
  } catch (error) {
    console.error('Error updating supplement:', error);
    throw error;
  }
};

// Delete supplement (admin only)
export const deleteSupplement = async (supplementId) => {
  try {
    await apiCall(`/supplements/${supplementId}`, {
      method: 'DELETE'
    });
    
    return { success: true };
  } catch (error) {
    console.error('Error deleting supplement:', error);
    throw error;
  }
};














